import { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { siteBrand, navLinks } from '@/mocks/manga';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header className="sticky top-0 z-50 w-full">
      <nav
        className={`w-full border-b transition-colors duration-300 ${
          scrolled || open
            ? 'border-background-200/80 bg-background-50/95 backdrop-blur'
            : 'border-transparent bg-background-50'
        }`}
      >
        <div className="mx-auto flex h-16 items-center justify-between px-4 md:px-6 lg:px-8">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-fire-line text-lg"></i>
            </span>
            <span className="whitespace-nowrap font-heading text-xl text-foreground-900">
              {siteBrand}
            </span>
          </Link>

          <div className="hidden items-center gap-1 md:flex">
            {navLinks.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === '/'}
                className={({ isActive }) =>
                  `rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-700 hover:bg-background-100 hover:text-primary-600'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 md:hidden"
          >
            <i className={`text-xl ${open ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {open && (
          <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
            <div className="flex flex-col gap-1">
              {navLinks.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  end={item.path === '/'}
                  className={({ isActive }) =>
                    `rounded-md px-3 py-2.5 text-sm font-medium ${
                      isActive
                        ? 'bg-primary-100 text-primary-700'
                        : 'text-foreground-700 hover:bg-background-100'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}